import { ACTIVITY_PHASES } from "./activityPhaseDefinitions";

function text(row) {
  return `${row?.tool ?? ""} ${row?.label ?? ""}`.toLowerCase();
}

function genericPhase(row) {
  const label = String(row?.label ?? "Working on your request");
  return {
    id: `observed:${label.toLowerCase()}`,
    title: label,
    narration: "I’m completing this part of your request.",
  };
}

export function activityPhase(row) {
  const value = text(row);
  return (
    ACTIVITY_PHASES.find((phase) =>
      phase.matches.some((match) => value.includes(match)),
    ) ?? genericPhase(row)
  );
}

export function activityPhases(rows = []) {
  return rows.reduce((phases, row) => {
    const phase = activityPhase(row);
    const previous = phases.at(-1);
    if (previous?.id === phase.id) previous.rows.push(row);
    else phases.push({ ...phase, rows: [row] });
    return phases;
  }, []);
}
